module.exports = __webpack_public_path__ + "static/media/DSA PHONO-ONE.baa13a73.png";